module.exports = __webpack_public_path__ + "static/media/HindVadodara-Regular.cac25233.woff";